
import ads1 from "@/assets/images/advertisement/ads1.webp";
import ads2 from "@/assets/images/advertisement/ads2.webp";
import ads3 from "@/assets/images/advertisement/ads3.webp";
import ads4 from "@/assets/images/advertisement/ads4.webp";
import ads5 from "@/assets/images/advertisement/ads5.webp";
import ads6 from "@/assets/images/advertisement/ads6.webp";
import ads7 from "@/assets/images/advertisement/ads7.webp";


export default {
  data() {
    return {
      images: [
        { src: ads1, link: "https://ifindcheaters.com/products/search-on-dating-sites/" },
        { src: ads2, link: "https://ifindcheaters.com/products/listing-locator/" },
        { src: ads3, link: "https://ifindcheaters.com/products/search-on-dating-sites/" },
        { src: ads4, link: "https://ifindcheaters.com/products/listing-locator/" },
        { src: ads5, link: "https://ifindcheaters.com/products/search-on-dating-sites/" },
        { src: ads6, link: "https://ifindcheaters.com/products/listing-locator/" },
        { src: ads7, link: "https://ifindcheaters.com/products/search-on-tinder/" },
      ],
      selectedImage: null
    };
  },
  methods: {
    getRandomImage() {
      const randomIndex = Math.floor(Math.random() * this.images.length);
      this.selectedImage = this.images[randomIndex] || null;
    },
  },
  mounted() {
    this.getRandomImage();
  }
};
